export const setAgentProfiles = (agentProfiles) => ({
    type: "SET_AGENT_PROFILES",
    payload: agentProfiles,
  });